/* ===== Narra US Open receipt UPLOAD flow =====
   Variant of the original scan page: the file picker is no longer forced to the
   camera, PDFs are accepted, and we keep the file's own metadata (name, size,
   modified date, EXIF when the file carries any) so entries can be sanity
   checked later. Posts to the same Apps Script web app, tagged form=receipts-upload.
   Appends to Sheet "Narra Receipt Entries" + saves the file to Drive "Narra Receipts". */
var CAPTURE_URL = 'https://script.google.com/macros/s/AKfycbyxHUnsmpq32bKDL3DHvV49a6Yz93Q1h619KIQ0yqZjNv10PXmyMAGft5vN6SbBLxmRmA/exec';
var MAX_BYTES = 12 * 1024 * 1024;

function submitEntry(form, data){
  var body = { form: form };
  for (var k in data){ if (data.hasOwnProperty(k)) body[k] = data[k]; }
  try {
    return fetch(CAPTURE_URL, { method:'POST', mode:'no-cors', body: JSON.stringify(body) });
  } catch(e){ return Promise.resolve(); }
}

/* ---- EXIF: pull the ASCII tags we care about out of a JPEG's APP1 segment.
        Returns {} for screenshots, PNGs, PDFs and anything already stripped. ---- */
function readExif(buf){
  try {
    var dv = new DataView(buf), out = {};
    if (dv.getUint16(0) !== 0xFFD8) return out;          // not a JPEG
    var off = 2, len = dv.byteLength, app1 = -1;
    while (off < len - 4){
      if (dv.getUint8(off) !== 0xFF) break;
      var marker = dv.getUint8(off + 1), size = dv.getUint16(off + 2);
      if (marker === 0xE1 && dv.getUint32(off + 4) === 0x45786966){ app1 = off + 10; break; }
      if (marker === 0xDA) break;                        // start of scan, no EXIF
      off += 2 + size;
    }
    if (app1 < 0) return out;

    var little = dv.getUint16(app1) === 0x4949;
    var ifd0 = app1 + dv.getUint32(app1 + 4, little);
    var TAGS = { 0x010F:'make', 0x0110:'model', 0x0131:'software', 0x0132:'dateTime',
                 0x9003:'dateTimeOriginal', 0x9004:'dateTimeDigitized' };

    function ascii(entry){
      var count = dv.getUint32(entry + 4, little);
      var at = count > 4 ? app1 + dv.getUint32(entry + 8, little) : entry + 8;
      var s = '';
      for (var i = 0; i < count && at + i < len; i++){
        var c = dv.getUint8(at + i);
        if (c === 0) break;
        s += String.fromCharCode(c);
      }
      return s.trim();
    }

    function walk(dir){
      if (dir < 0 || dir + 2 > len) return;
      var n = dv.getUint16(dir, little);
      for (var i = 0; i < n; i++){
        var entry = dir + 2 + i * 12;
        if (entry + 12 > len) return;
        var tag = dv.getUint16(entry, little), type = dv.getUint16(entry + 2, little);
        if (tag === 0x8769) walk(app1 + dv.getUint32(entry + 8, little));      // Exif sub IFD
        else if (tag === 0x8825) out.hasGps = true;                            // presence only
        else if (TAGS[tag] && type === 2){ var v = ascii(entry); if (v) out[TAGS[tag]] = v; }
      }
    }
    walk(ifd0);
    return out;
  } catch(e){ return {}; }
}

(function(){
  var drop=document.getElementById('drop'), file=document.getElementById('file');
  var preview=document.getElementById('preview'), pimg=document.getElementById('pimg');
  var spin=document.getElementById('spin'), ocrline=document.getElementById('ocrline');
  var fields=document.getElementById('fields'), err=document.getElementById('err');
  var fileB64=null, ocrTotal=null, ocrText='', meta={};

  drop.addEventListener('click', function(){ file.click(); });
  drop.addEventListener('dragover', function(e){ e.preventDefault(); drop.classList.add('over'); });
  drop.addEventListener('dragleave', function(){ drop.classList.remove('over'); });
  drop.addEventListener('drop', function(e){ e.preventDefault(); drop.classList.remove('over'); if(e.dataTransfer.files[0]) handle(e.dataTransfer.files[0]); });
  file.addEventListener('change', function(){ if(file.files[0]) handle(file.files[0]); });

  function fail(msg){ err.style.display='block'; err.textContent=msg; spin.style.display='none'; }
  function say(html){ spin.style.display='none'; ocrline.style.display='block'; ocrline.innerHTML=html; }

  function baseMeta(f){
    var m = {
      fileName: f.name || '',
      fileSize: f.size || 0,
      fileType: f.type || '',
      fileModified: f.lastModified ? new Date(f.lastModified).toISOString() : '',
      uploadedAt: new Date().toISOString(),
      screen: (window.screen ? screen.width + 'x' + screen.height : ''),
      referrer: document.referrer || ''
    };
    try { m.tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch(e){ m.tz=''; }
    return m;
  }

  function handle(f){
    err.style.display='none';
    meta = baseMeta(f);

    if(f.size > MAX_BYTES) return fail('That file is over 12MB. A screenshot of your Amazon order works best.');

    var isPdf = (f.type === 'application/pdf') || /\.pdf$/i.test(f.name || '');
    if(isPdf) return handlePdf(f);

    // Read the original bytes first: the canvas step below strips every EXIF tag.
    var mr = new FileReader();
    mr.onload = function(){
      var ex = readExif(mr.result);
      for (var k in ex){ if (ex.hasOwnProperty(k)) meta[k] = ex[k]; }
      handleImage(f);
    };
    mr.onerror = function(){ handleImage(f); };
    mr.readAsArrayBuffer(f.slice(0, 256 * 1024));
  }

  function handlePdf(f){
    var r = new FileReader();
    r.onload = function(){
      fileB64 = r.result;
      pimg.style.display='none';
      preview.style.display='block';
      preview.setAttribute('data-file', f.name || 'receipt.pdf');
      fields.style.display='block';
      say('We have your PDF, <b>' + (f.name || 'receipt.pdf') + '</b>. We cannot read a total out of a PDF, so type it in below and you are set.');
    };
    r.onerror = function(){ fail('We could not read that PDF. Try a screenshot of your Amazon order instead.'); };
    r.readAsDataURL(f);
  }

  function handleImage(f){
    var img=new Image();
    img.onload=function(){
      var s1=Math.min(1,1600/Math.max(img.width,img.height));
      var big=document.createElement('canvas'); big.width=Math.round(img.width*s1); big.height=Math.round(img.height*s1);
      big.getContext('2d').drawImage(img,0,0,big.width,big.height);
      var s2=Math.min(1,900/Math.max(img.width,img.height));
      var small=document.createElement('canvas'); small.width=Math.round(img.width*s2); small.height=Math.round(img.height*s2);
      small.getContext('2d').drawImage(img,0,0,small.width,small.height);
      fileB64=small.toDataURL('image/jpeg',0.6);
      meta.imageW = img.width; meta.imageH = img.height;
      pimg.style.display=''; pimg.src=fileB64; preview.style.display='block'; preview.removeAttribute('data-file');
      fields.style.display='block';
      runOcr(big);
    };
    img.onerror=function(){ fail("We could not open that file. A screenshot, a JPG or a PNG works best."); };
    img.src=URL.createObjectURL(f);
  }

  function runOcr(canvas){
    spin.style.display='block'; ocrline.style.display='none';
    if(typeof Tesseract==='undefined'){ return say("Type your receipt total below and you are set."); }
    Tesseract.recognize(canvas,'eng').then(function(res){
      spin.style.display='none';
      ocrText=(res.data&&res.data.text)||'';
      var totals=[];
      ocrText.split('\n').forEach(function(line){
        var mm=line.match(/(\d{1,4}\.\d{2})/g); if(!mm) return;
        var v=parseFloat(mm[mm.length-1]);
        if(/total|amount|balance|due/i.test(line)) totals.push({v:v,w:2}); else totals.push({v:v,w:1});
      });
      var best=null; totals.forEach(function(t){ if(!best||t.w>best.w||(t.w===best.w&&t.v>best.v)) best=t; });
      if(best&&best.v>0){ ocrTotal=best.v.toFixed(2); document.getElementById('total').value=ocrTotal;
        say('We read a total of <b>$'+ocrTotal+'</b>. Double check it below and correct it if we misread.');
      } else { say("We could not read the total off that file. Type it in below and you are set."); }
    }).catch(function(){ say("We could not read the total off that file. Type it in below and you are set."); });
  }

  document.getElementById('submit').addEventListener('click', function(){
    err.style.display='none';
    var total=document.getElementById('total').value.trim().replace(/[^0-9.]/g,'');
    var name=document.getElementById('name').value.trim();
    var email=document.getElementById('email').value.trim();
    var ordernum=document.getElementById('ordernum').value.trim();
    if(!fileB64) return fail('Upload your Amazon receipt first.');
    if(!total||isNaN(parseFloat(total))||parseFloat(total)<=0) return fail('Confirm your receipt total.');
    if(!name) return fail('Add your name.');
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Add a valid email so we can send your cashback.');
    if(!ordernum) return fail('Add your Amazon order number.');
    submitEntry('receipts-upload', {
      name:name, email:email, orderNumber:ordernum, total:total, ocrTotal:ocrTotal,
      photo:fileB64, ua:navigator.userAgent,
      meta: JSON.stringify(meta),
      fileName: meta.fileName, fileSize: meta.fileSize, fileType: meta.fileType,
      fileModified: meta.fileModified, exifTaken: meta.dateTimeOriginal || meta.dateTime || '',
      exifDevice: [meta.make, meta.model].filter(Boolean).join(' ')
    });
    document.getElementById('scanmain').style.display='none';
    document.getElementById('done').style.display='block';
    document.getElementById('scan').scrollIntoView({behavior:'smooth',block:'start'});
  });
})();
